import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onBeforeMount, computed } from 'vue';
import { useStore } from 'vuex';

import SearchView from '@/views/search/SearchView.vue';
import SearchDisableExpired from '@/views/search/SearchDisableExpired.vue';
import SearchDisableNoPortfolio from '@/views/search/SearchDisableNoPortfolio.vue';
import SearchDisableLockUser from '@/views/search/SearchDisableLockUser.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const store = useStore();
const outsideSearchPeriod = computed(() => {
  return store.getters['userMenu/outsideSearchPeriod'];
});
const notSubmittedPortfolio = computed(() => {
  return store.getters['userMenu/notSubmittedPortfolio'];
});
const searchableOrder = computed(() => {
  return store.getters['userMenu/searchableOrder'];
});
const isSearchLockUser = computed(() => {
  return store.getters['userMenu/isSearchLockUser'];
});

onBeforeMount(async () => {
  await store.dispatch('userMenu/receive');
});

return (_ctx: any,_cache: any) => {
  return (_unref(isSearchLockUser))
    ? (_openBlock(), _createBlock(SearchDisableLockUser, { key: 0 }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (_unref(outsideSearchPeriod))
          ? (_openBlock(), _createBlock(SearchDisableExpired, { key: 0 }))
          : _createCommentVNode("", true),
        (_unref(notSubmittedPortfolio))
          ? (_openBlock(), _createBlock(SearchDisableNoPortfolio, { key: 1 }))
          : _createCommentVNode("", true),
        (_unref(searchableOrder))
          ? (_openBlock(), _createBlock(SearchView, { key: 2 }))
          : _createCommentVNode("", true)
      ], 64))
}
}

})